export class WalletCondition {
    loyaltyAmountFixed: number
    loyaltyfixedCoin: number;
    loyaltyUsingPercentage: number;
    isLoyaltyMinimum: boolean;
    loyaltyMinimumOrder: number;
    isLoyaltyMaximum: boolean;
    loyaltyMaximumOrder: number;
    activityUsingPercentage: number;
    isActivityMinimumOrder: boolean;
    activityMinimumOrder: number;
    isActivityMaximumOrder: boolean;
    activityMaximumOrder: number;
    eventWalletUsingPercentage: number;
    isEventMinimumOrder: boolean;
    eventMinimumOrder: number;
    isEventMaximumOrder: boolean;
    eventMaximumOrder: number;
    referWalletUsingPercentage: number;
    isReferMinimumOrder: boolean;
    referMinimumOrder: number;
    isReferMaximumOrder: boolean;
    referMaximumOrder: number;
}